const apiConfig = {
    baseURL: "https://api.themoviedb.org/3/",
    apiKey: process.env.REACT_APP_API_KEY,
    getImage: (imgSrc) => `https://image.tmdb.org/t/p/original/${imgSrc}`,
};

export default apiConfig;
